module.exports = __webpack_public_path__ + "img/movies.129a86d9.png";